import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr'

export default class extends Controller {
  static values = { maxDate: String }

  connect() {
    flatpickr.localize(French)

    const options = {
      dateFormat: 'd/m/Y',
      disableMobile: true,
      allowInput: true,
      parseDate: (datestr, format) => {
        const parsed = flatpickr.parseDate(datestr, format)
        this.element.classList.toggle('border-danger', parsed === undefined)
        return parsed
      },
    }

    if (this.hasMaxDateValue) {
      options.maxDate = this.maxDateValue
    }

    this.picker = flatpickr(this.element, options)
  }

  disconnect() {
    this.picker?.destroy()
  }
}
